module.exports = __webpack_public_path__ + "static/media/psapp-nav.80352172.png";